




import Vue from "vue";

export default Vue.extend({
  name: "IntersectObserver",
  data() {
    return <{
      observer: IntersectionObserver | null
    }> {
      observer: null
    };
  },

  props: {
    root: {
      type: Object as () => Element,
      default: null
    },
    rootMargin: {
      type: String,
      default: "0px"
    },
    threshold: {
      type: Array as () => number[],
      default: [1.0]
    }
  },

  mounted(): void {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.$emit("intersecting");
      }
    }, {
      root: this.root,
      rootMargin: this.rootMargin,
      threshold: this.threshold
    });

    this.observer.observe(this.$el);
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.unobserve(this.$el);
    }
  }
});
